import * as React from 'react'

const OncePerWeekIcon = require('./once_per_week.svg')
const OncePerMonthIcon = require('./once_per_month.svg')
const TwicePerMonthIcon = require('./twice_per_month.svg')
const OnceEveryOtherWeekIcon = require('./once_every_other_week.svg')
const OtherIcon = require('./other_icon.svg')

interface OwnProps {
  value?: React.ReactText | React.ReactText[] | boolean
}

export const ButtonIcon: React.FunctionComponent<OwnProps> = (props) => {
  const { value } = props

  let Icon = OtherIcon

  switch (value) {
    case 'weekly':
      Icon = OncePerWeekIcon
      break
    case 'biweekly':
      Icon = OnceEveryOtherWeekIcon
      break
    case 'twice_monthly':
      Icon = TwicePerMonthIcon
      break
    case 'monthly':
      Icon = OncePerMonthIcon
      break
    default:
  }

  return <Icon />
}
